import { render, staticRenderFns } from "./BookDetail.vue?vue&type=template&id=04234fb8&scoped=true&"
import script from "./BookDetail.vue?vue&type=script&lang=js&"
export * from "./BookDetail.vue?vue&type=script&lang=js&"
import style0 from "./BookDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BookDetail.vue?vue&type=style&index=1&lang=css&"
import style2 from "./BookDetail.vue?vue&type=style&index=2&id=04234fb8&lang=scss&scoped=true&"
import style3 from "./BookDetail.vue?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04234fb8",
  null
  
)

export default component.exports